<script>
export default {
  data() {
    return {};
  },
  computed: {
  },
};
</script>

<template>
  <section id="brands">
    <div class="marquee">
      <ul class="marquee__content">
        <img :src="require(`@/assets/images/brands/all-brands.png`)" alt="" />
      </ul>

      <ul aria-hidden="true" class="marquee__content">
        <img :src="require(`@/assets/images/brands/all-brands.png`)" alt="" />
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  #brands {
    margin-top: 2rem;
    position: relative;
  }

  .marquee {
    --gap: 1rem;
    position: relative;
    display: flex;
    overflow: hidden;
    user-select: none;
    gap: var(--gap);
  }

  .marquee__content {
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
    gap: var(--gap);
    min-width: 100%;
    animation: scroll 20s linear infinite;
  }

  @keyframes scroll {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - var(--gap)));
    }
  }
</style>